<template>
  <div class="tabChangebg0-title">
    <div class="tabClub">
      <div :class="[hasTab > 1 ? 'tab-cicle-completed' : hasTab == 1 ? 'tab-cicle-active' : 'tab-cicle-normal']">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" v-if="hasTab > 1">
          <path d="M15.145 7l-6.268 6.268-3.333-3.333L5 9.391" stroke="#Ffff" stroke-width="1.7" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <span :class="[hasTab >= 1 ? 'tab-title active' : 'tab-title']">{{ "个人信息" }}</span>
    </div>
    <div :class="[hasTab >= 2 ? 'line' : 'line-normal']"></div>
    <div class="tabClub">
      <div :class="[hasTab > 2 ? 'tab-cicle-completed' : hasTab == 2 ? 'tab-cicle-active' : 'tab-cicle-normal']">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" v-if="hasTab > 2">
          <path d="M15.145 7l-6.268 6.268-3.333-3.333L5 9.391" stroke="#Ffff" stroke-width="1.7" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <span :class="[hasTab >= 2 ? 'tab-title active' : 'tab-title']">{{ "组织与角色" }}</span>
    </div>

    <div :class="[hasTab >= 3 ? 'line' : 'line-normal']"></div>
    <div class="tabClub">
      <div :class="[hasTab > 3 ? 'tab-cicle-completed' : hasTab == 3 ? 'tab-cicle-active' : 'tab-cicle-normal']">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" v-if="hasTab > 3">
          <path d="M15.145 7l-6.268 6.268-3.333-3.333L5 9.391" stroke="#Ffff" stroke-width="1.7" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <span :class="[hasTab >= 3 ? 'tab-title active' : 'tab-title']">{{ "密码设置" }}</span>
    </div>

    <div :class="[hasTab >= 4 ? 'line' : 'line-normal']"></div>
    <div class="tabClub">
      <div :class="[hasTab > 4 ? 'tab-cicle-completed' : hasTab == 4 ? 'tab-cicle-active' : 'tab-cicle-normal']">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" v-if="hasTab > 4">
          <path d="M15.145 7l-6.268 6.268-3.333-3.333L5 9.391" stroke="#Ffff" stroke-width="1.7" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <span :class="[hasTab >= 4 ? 'tab-title active' : 'tab-title']">{{ "联系方式" }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
defineProps(['hasTab', 'op'])
</script>
<style scoped>
.tabChangebg0-title {
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: center;
}

.tabClub {
  display: flex;
  flex-flow: column;
  align-items: center;
  position: relative;
  min-width: 100px;
}

.tab-cicle-active {
  width: 28px;
  height: 28px;
  border: 2px solid #2655f1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2655f1;
  margin-bottom: 8px;
  z-index: 1;
  background: white;
}

.tab-cicle-completed {
  width: 28px;
  height: 28px;
  background: #2655f1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-bottom: 8px;
  z-index: 1;
}

.tab-cicle-normal {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  z-index: 1;
  background: white;
}

.line {
  height: 2px;
  flex: 1;
  background: #2655f1;
  align-self: center;
  margin: 0;
  z-index: 0;
}

.line-normal {
  height: 2px;
  flex: 1;
  background: #e0e0e0;
  align-self: center;
  margin: 0;
  z-index: 0;
}

.tab-title {
  margin-top: 8px;
  font-size: 14px;
  color: #999999;
  padding: 4px 12px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.tab-title.active {
  color: #2655f1;
  background: #e6f0ff;
  font-weight: 500;
}

.tab-cicle-completed svg {
  width: 16px;
  height: 16px;
}
</style>